import User from '~/api/user'
import News from '~/api/news'
import Public from '~/api/public'
import Affiliate from '~/api/affiliate'
import Shop from '~/api/shop'
import Marketing from '~/api/marketing'
import Ident from '~/api/ident'
import Pfando from '~/api/pfando'
import AlternativeOffer from '~/api/alternativeOffer'
import Creditlife from '~/api/creditlife'
import Plus1 from '~/api/plus1'
import Audio from '~/api/audio'

export default (context, inject) => {
  // Initialize API factories
  const factories = {
    user: User(context.$axios, context.$alert),
    news: News(context.$axios, context.$alert),
    public: Public(context.$axios, context.$alert),
    affiliate: Affiliate(context.$axios, context.$alert),
    shop: Shop(context.$axios, context.$alert),
    marketing: Marketing(context.$axios, context.$alert),
    ident: Ident(context.$axios, context.$alert),
    pfando: Pfando(context.$axios, context.$alert),
    alternativeOffer: AlternativeOffer(context.$axios, context.$alert),
    creditlife: Creditlife(context.$axios, context.$alert),
    plus1: Plus1(context.$axios, context.$alert),
    audio: Audio(context.$axios, context.$alert)
  }

  // Inject $api
  inject('api', factories)
}
